import { AxiosInstance } from 'axios';
import React, { useEffect, useState } from 'react';
import { getAuthTokens } from 'utils/cookies';

interface Props {
  instances: AxiosInstance[];
}
export const AxiosInterceptorsToken: React.FC<Props> = ({ children, instances }) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    const ids = instances.map((instance) => {
      const id = instance.interceptors.request.use((config) => {
        const { token } = getAuthTokens();
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + token,
          };
        }
        return config;
      });
      return { id, instance };
    });

    setInit(true);
    return () => {
      ids.forEach(({ instance, id }) => {
        instance.interceptors.request.eject(id);
      });
    };
  }, [instances]);

  return <>{init && children}</>;
};
